import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { ColorConversionState } from '@/store/types/color-conversion.state';

export const actions: ActionTree<ColorConversionState, RootState> = {

}